import React from 'react';
import {classes, style} from './doppe-action-modal-iframe-content.st.css';


export const DoppeActionModalIframeContent = React.memo(function DoppeActionModalIframeContent(
    props: React.HTMLAttributes<any> & {
        src: string,
        withMinHeight?: boolean,
    }
) {
    const {
        src,
        withMinHeight = false,

        className,
        ...htmlAttributes
    } = props;

    return (
        <iframe
            {...htmlAttributes}
            className={style(classes.root, {withMinHeight: withMinHeight})}
            title="Iframe Embed"
            src={src}
        />
    );
});